import React, { FC } from 'react'
import { FontSizeProps, theme } from '../../../theme'

export const WaterBathIcon: FC<{ size?: FontSizeProps }> = ({
  size = 'x2',
}) => {
  return (
    <svg
      width={theme.fontSizes[size]}
      height={theme.fontSizes[size]}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 1C13 0.447715 13.4477 0 14 0C14.5523 0 15 0.447715 15 1V3C15 3.55228 14.5523 4 14 4H13V5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5V3C11 2.96548 11.0017 2.93137 11.0052 2.89776C11.0564 2.3935 11.4822 2 12 2H13V1ZM8 2C7.44772 2 7 2.44772 7 3V4H6C5.44772 4 5 4.44772 5 5V7C5 7.55228 5.44772 8 6 8C6.55228 8 7 7.55228 7 7V6H8C8.55229 6 9 5.55228 9 5V3C9 2.44772 8.55229 2 8 2ZM1 10C0.447715 10 0 10.4477 0 11C0 11.5523 0.447715 12 1 12H2V18C2 19.1046 2.89543 20 4 20H16C17.1046 20 18 19.1046 18 18V12H19C19.5523 12 20 11.5523 20 11C20 10.4477 19.5523 10 19 10H1Z"
        fill="black"
      />
    </svg>
  )
}
